
                  export default function (Component) {
                      Component.__source = "library/components/VabTheme/index.vue"
                  }
              